module.exports = __webpack_public_path__ + "img/feature-tile-icon-01.336be095.svg";